'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

var _isPlainObject2 = require('lodash/isPlainObject');

var _isPlainObject3 = _interopRequireDefault(_isPlainObject2);

var _isEmpty2 = require('lodash/isEmpty');

var _isEmpty3 = _interopRequireDefault(_isEmpty2);

var _invertBy2 = require('lodash/invertBy');

var _invertBy3 = _interopRequireDefault(_invertBy2);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _defaultTo2 = require('lodash/defaultTo');

var _defaultTo3 = _interopRequireDefault(_defaultTo2);

var _dec, _dec2, _dec3, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactRedux = require('react-redux');

var _playlist = require('redux/modules/playlist');

var playlistActions = _interopRequireWildcard(_playlist);

var _playlists = require('redux/modules/playlists');

var _auth = require('redux/modules/auth');

var _audioplayer = require('redux/modules/audioplayer');

var audioplayerActions = _interopRequireWildcard(_audioplayer);

var _reduxConnect = require('redux-connect');

var _components = require('components');

var _reactI18next = require('react-i18next');

var _playlists2 = require('selectors/playlists');

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _reactRouterRedux = require('react-router-redux');

var _toastr = require('helpers/toastr');

var _toastr2 = _interopRequireDefault(_toastr);

var _reactHtml5video = require('react-html5video');

var _responseCodes = require('helpers/responseCodes');

var _downloads = require('helpers/downloads');

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _projects = require('helpers/projects');

var _AudioPlayer = require('helpers/AudioPlayer');

var _AudioPlayer2 = _interopRequireDefault(_AudioPlayer);

var _asyncPromise = require('helpers/async-promise');

var _asyncPromise2 = _interopRequireDefault(_asyncPromise);

var _TrackPartHeader = require('components/TrackPartHeader/TrackPartHeader');

var _TrackPartHeader2 = _interopRequireDefault(_TrackPartHeader);

var _MyPlaylistsAddIcon = require('components/MyPlaylistsAddIcon/MyPlaylistsAddIcon');

var _MyPlaylistsAddIcon2 = _interopRequireDefault(_MyPlaylistsAddIcon);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _TrackPlayPauseButton = require('components/TrackPlayPauseButton/TrackPlayPauseButton');

var _TrackPlayPauseButton2 = _interopRequireDefault(_TrackPlayPauseButton);

var _PlaylistNavButtons = require('./components/PlaylistNavButtons/PlaylistNavButtons');

var _PlaylistNavButtons2 = _interopRequireDefault(_PlaylistNavButtons);

var _PlaylistAlbum = require('components/Playlist/PlaylistAlbum/PlaylistAlbum');

var _PlaylistAlbum2 = _interopRequireDefault(_PlaylistAlbum);

var _PlaylistFeedbackForm = require('components/Playlist/PlaylistFeedbackForm/PlaylistFeedbackForm');

var _PlaylistFeedbackForm2 = _interopRequireDefault(_PlaylistFeedbackForm);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./Playlist.scss');

var changeUrlOnTrackChange = false; //TODO: temporary?
var scrollPosition = 0;

var Playlist = (_dec = (0, _reduxConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState,
        key = _ref.params.key,
        location = _ref.location;

    var user = getState().auth.user;

    // if we just change autoplay index by replaceState then not reload playlist
    if (location.action !== 'REPLACE') {
      var method = user ? 'load' : 'loadByKey';
      return (0, _asyncPromise2.default)(dispatch(playlistActions[method]({ key: key })).promise);
    }
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state, ownProps) {
  return {
    album: (0, _playlists2.processAlbum)(state),
    autoPlayIndex: ownProps.location.query.index ? Number(ownProps.location.query.index) : null,
    currentTrackIndex: state.audioplayer.currentTrackIndex,
    downloadTracksLoading: state.playlist.downloadTracksLoading,
    format: state.playlist.format,
    humanizedPosition: state.audioplayer.humanizedPosition,
    partTracks: (0, _playlists2.getPartTracks)(state),
    playerAlbum: state.audioplayer.album,
    playerStatus: state.audioplayer.playerStatus,
    playerTracks: state.audioplayer.tracks,
    playlistEmail: (0, _get3.default)(state, 'playlist.playlistData.email', ''),
    playlistKey: ownProps.params.key,
    playlistLoadError: state.playlist.playlistLoadError,
    playlistLoading: state.playlist.playlistLoading,
    playlistName: (0, _get3.default)(state, 'playlist.playlistData.name', ''),
    playlistSurname: (0, _get3.default)(state, 'playlist.playlistData.surname', ''),
    playlistUser: (0, _get3.default)(state, 'playlist.playlistData.user', {}),
    playStatsAlbums: state.playstats.albums,
    playStatsTracks: state.playstats.tracks,
    pressLoading: state.playlists.pressLoading,
    recipientId: Number(ownProps.params.recipientId),
    tracks: (0, _playlists2.processTracks)(state),
    typeFilter: state.playlists.typeFilter,
    user: state.auth.user
  };
}, (0, _extends4.default)({}, playlistActions, audioplayerActions, { loadPress: _playlists.loadPress, setRedirect: _auth.setRedirect, setLoginData: _auth.setLoginData, pushState: _reactRouterRedux.push, replaceState: _reactRouterRedux.replace })), _dec3 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = _dec3(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(Playlist, _Component);

  function Playlist() {
    var _ref2;

    (0, _classCallCheck3.default)(this, Playlist);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref2 = Playlist.__proto__ || (0, _getPrototypeOf2.default)(Playlist)).call.apply(_ref2, [this].concat(args)));

    _this.state = { checkedTracks: {}, autoPlayStarted: false, isAllTracksSelected: false };
    return _this;
  }

  (0, _createClass3.default)(Playlist, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.isPlaylistDisallowed();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          clearPlaylistError = _props.clearPlaylistError,
          playlistLoadError = _props.playlistLoadError,
          t = _props.t,
          replaceState = _props.replaceState;


      setTimeout(function () {
        if (!playlistLoadError) {
          return false;
        }

        var errorMsg = void 0;
        var timeOut = 4000;
        if (playlistLoadError.code === _responseCodes.playlistCodes.notAvailable) {
          errorMsg = _react2.default.createElement(
            'span',
            null,
            t('Project is no longer available')
          );
        }
        if (playlistLoadError.code === _responseCodes.playlistCodes.contentLocked) {
          errorMsg = _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'p',
              null,
              t('Content locked to another device'),
              '.'
            ),
            _react2.default.createElement(
              'p',
              null,
              t('You can listen again on your original device via the email link.')
            ),
            _react2.default.createElement(
              'p',
              null,
              t('Or, if you have a CRight account, simply log in to listen again.')
            ),
            _react2.default.createElement(
              'p',
              null,
              t('If you don’t have an account, or have forgotten your password, click “FORGOT PASSWORD” on the homepage.')
            )
          );
          timeOut = 12000;
        }
        if (errorMsg) {
          _toastr2.default.warning({ component: errorMsg, timeOut: timeOut });
          clearPlaylistError();
          replaceState({ pathname: '/' });
        }
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      var _this2 = this;

      var currentTrackIndex = props.currentTrackIndex,
          playerStatus = props.playerStatus,
          playerAlbum = props.playerAlbum,
          album = props.album,
          autoPlayIndex = props.autoPlayIndex,
          tracks = props.tracks,
          user = props.user;
      var autoPlayStarted = this.state.autoPlayStarted;


      if (this.isPlaylistDisallowed(props)) {
        return false;
      }

      if (changeUrlOnTrackChange) {
        // change url after page was loaded to contain autoplay index
        if (playerAlbum.project_id === album.project_id && playerStatus !== _AudioPlayer2.default.status.stop) {
          setTimeout(function () {
            return _this2.changeTrackUrl(currentTrackIndex);
          }, 200);
        }
      }

      if (!autoPlayStarted && playerStatus === _AudioPlayer2.default.status.stop) {
        // if url contains autoplay track index && props have album and tracks || album played from email link
        var playTrackIndex = autoPlayIndex !== null && tracks[autoPlayIndex] ? autoPlayIndex : !user && tracks[0] ? 0 : null;

        if (playTrackIndex !== null) {
          this.setState({ autoPlayStarted: true });
          setTimeout(function () {
            return _this2.play(playTrackIndex);
          }, 500);
        }
      }
    }
  }, {
    key: 'onVideoEnded',
    value: function onVideoEnded(e, track) {
      console.log(e, track);
    }
  }, {
    key: 'getCheckedTracksArray',
    value: function getCheckedTracksArray(checkedTracks) {
      return (0, _invertBy3.default)(checkedTracks || this.state.checkedTracks || {}).true || [];
    }
  }, {
    key: 'redirectToAuth',
    value: function redirectToAuth(url, loginData) {
      var _props2 = this.props,
          playlistKey = _props2.playlistKey,
          pushState = _props2.pushState,
          user = _props2.user;

      if (playlistKey && !user) {
        this.props.setRedirect('/playlists/fromkey/' + playlistKey);
        this.props.setLoginData((0, _isPlainObject3.default)(loginData) ? loginData : {});
        pushState(url);
      }
    }
  }, {
    key: 'isPlaylistDisallowed',
    value: function isPlaylistDisallowed(nextProps) {
      var _ref3 = nextProps || this.props,
          playlistLoadError = _ref3.playlistLoadError;

      var res = false;

      if ((nextProps && !this.props.playlistLoadError || !nextProps) && playlistLoadError) {
        var redirectData = (0, _get3.default)(playlistLoadError, 'data', {});
        redirectData._code = playlistLoadError.code;

        if (playlistLoadError.code === _responseCodes.playlistCodes.loginRequired) {
          this.redirectToAuth('/login', redirectData);
          res = true;
        } else if (playlistLoadError.code === _responseCodes.playlistCodes.registrationRequired) {
          this.redirectToAuth('/registration', redirectData);
          res = true;
        }
      }

      return res;
    }
  }, {
    key: 'changeTrackUrl',
    value: function changeTrackUrl(index) {
      var _props3 = this.props,
          location = _props3.location,
          replaceState = _props3.replaceState;

      if (Number(location.query.index) !== index) {
        scrollPosition = document ? document.body.scrollTop : 0;
        replaceState({ pathname: location.pathname, query: { index: index } });
        if (scrollPosition) {
          document.body.scrollTop = scrollPosition;
        }
      }
    }
  }, {
    key: 'toggleTrackChecked',
    value: function toggleTrackChecked(e, id) {
      var checkedTracks = (0, _extends4.default)({}, this.state.checkedTracks, (0, _defineProperty3.default)({}, id, e.target.checked));
      var checkedTracksArr = this.getCheckedTracksArray(checkedTracks);
      var tracks = this.props.tracks;


      this.setState({ checkedTracks: checkedTracks, isAllTracksSelected: checkedTracksArr.length === tracks.length });
    }
  }, {
    key: 'play',
    value: function play(index) {
      var _props4 = this.props,
          playAlbum = _props4.playAlbum,
          album = _props4.album,
          tracks = _props4.tracks,
          currentTrackIndex = _props4.currentTrackIndex;

      playAlbum({ album: album, tracks: tracks, currentTrackIndex: (0, _defaultTo3.default)(index, currentTrackIndex) });
    }
  }, {
    key: 'selectAll',
    value: function selectAll() {
      var tracks = this.props.tracks;

      var checkedTracks = {};
      tracks.map(function (track) {
        checkedTracks[track.track_number] = true;
      });
      this.setState({ checkedTracks: checkedTracks, isAllTracksSelected: true });
    }
  }, {
    key: 'selectNone',
    value: function selectNone() {
      this.setState({ checkedTracks: {}, isAllTracksSelected: false });
    }
  }, {
    key: 'downloadPress',
    value: function downloadPress() {
      var _props5 = this.props,
          pressLoading = _props5.pressLoading,
          t = _props5.t,
          album = _props5.album;


      if (pressLoading) {
        return _toastr2.default.info(t('Downloading is in progress'));
      }

      this.props.loadPress({ key: album.contentKey }).promise.then(function (resp) {
        var filename = resp.data.filename;

        if (filename) {
          (0, _downloads.download)('' + _config2.default.app.urlParts.press + filename);
        }
      });
    }
  }, {
    key: 'isTrackDenied',
    value: function isTrackDenied(_ref4) {
      var track = _ref4.track,
          album = _ref4.album;
      var _props6 = this.props,
          playStatsTracks = _props6.playStatsTracks,
          playStatsAlbums = _props6.playStatsAlbums;

      return (0, _get3.default)(playStatsTracks, [track.id, 'isDenied']) || (0, _get3.default)(playStatsAlbums, [album.project_id, 'isDenied']);
    }
  }, {
    key: 'renderFormatCheckbox',
    value: function renderFormatCheckbox(checkboxFormat) {
      var _props7 = this.props,
          selectFormat = _props7.selectFormat,
          format = _props7.format;

      return _react2.default.createElement(_components.Checkbox, {
        className: 'padding-5 inline',
        checked: format === checkboxFormat,
        small: true,
        thin: true,
        textAfter: checkboxFormat,
        onChange: function onChange() {
          return selectFormat(checkboxFormat);
        }
      });
    }
  }, {
    key: 'renderContentButton',
    value: function renderContentButton() {
      var _this3 = this;

      var _props8 = this.props,
          t = _props8.t,
          playlistKey = _props8.playlistKey,
          user = _props8.user,
          playlistEmail = _props8.playlistEmail,
          playlistName = _props8.playlistName,
          playlistSurname = _props8.playlistSurname,
          playlistUser = _props8.playlistUser;

      var isPlayByKey = playlistKey && !user;
      var redirectData = !(0, _isEmpty3.default)(playlistUser) ? playlistUser : { email: playlistEmail, name: playlistName, surname: playlistSurname };
      redirectData._code = _responseCodes.playlistCodes.loginRequired;

      return !isPlayByKey ? null : _react2.default.createElement(
        'button',
        {
          type: 'button',
          className: 'btn btn-primary margin-left-15 margin-top-10',
          onClick: function onClick() {
            return _this3.redirectToAuth('/login', redirectData);
          }
        },
        t('My content')
      );
    }
  }, {
    key: 'renderSelectAll',
    value: function renderSelectAll() {
      var _this4 = this;

      var t = this.props.t;
      var isAllTracksSelected = this.state.isAllTracksSelected;


      return _react2.default.createElement(
        'div',
        { className: styles.selectAllContainer },
        _react2.default.createElement(_components.Checkbox, {
          className: 'padding-5 inline',
          checked: isAllTracksSelected,
          small: true,
          thin: true,
          textBefore: t('Select all'),
          onChange: function onChange() {
            return isAllTracksSelected ? _this4.selectNone() : _this4.selectAll();
          }
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var _props9 = this.props,
          playlistLoading = _props9.playlistLoading,
          t = _props9.t,
          album = _props9.album,
          tracks = _props9.tracks,
          partTracks = _props9.partTracks,
          humanizedPosition = _props9.humanizedPosition,
          currentTrackIndex = _props9.currentTrackIndex,
          playerTracks = _props9.playerTracks,
          format = _props9.format,
          user = _props9.user,
          playlistLoadError = _props9.playlistLoadError,
          playlistKey = _props9.playlistKey,
          typeFilter = _props9.typeFilter,
          pressLoading = _props9.pressLoading,
          playlistUser = _props9.playlistUser;


      if ((0, _get3.default)(playlistLoadError, 'code') === _responseCodes.playlistCodes.userConsentRequired) {
        return _react2.default.createElement(_components.UserConsent, { playlistKey: playlistKey });
      }

      var currentTrack = playerTracks[currentTrackIndex] || {};
      var checkedTracks = this.state.checkedTracks;


      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_components.Labels, { labels: album.subLabels, className: 'margin-bottom-10' }),
        _react2.default.createElement(
          'div',
          { className: (0, _bind2.default)('page', styles.playlist) },
          _react2.default.createElement(
            'div',
            { className: 'container-fluid' },
            _react2.default.createElement(_reactHelmet2.default, { title: t('Playlists') }),
            _react2.default.createElement(_PlaylistNavButtons2.default, {
              contentType: typeFilter || album.projectContentType,
              playlistKey: playlistKey,
              user: user
            }),
            _react2.default.createElement(_components.Loader, { show: playlistLoading, alignCenter: true }),
            _react2.default.createElement(_PlaylistAlbum2.default, { album: album }),
            album.audiovideo === _projects.projectTypes.audio && _react2.default.createElement(
              'div',
              { className: 'margin-top-20 margin-bottom-10' },
              !album.multipleBoxSets && album.downloadable && _react2.default.createElement(
                'div',
                { className: 'overflow-hidden margin-bottom-10' },
                this.renderSelectAll()
              ),
              partTracks.parts.map(function (part, index) {
                return _react2.default.createElement(
                  'div',
                  { key: 'part-' + part },
                  !!album.multipleBoxSets && _react2.default.createElement(
                    _TrackPartHeader2.default,
                    { part: part },
                    album.downloadable && !index && _this5.renderSelectAll()
                  ),
                  _react2.default.createElement(
                    _components.List,
                    null,
                    partTracks.tracks[part].map(function (trackIndex) {
                      return _react2.default.createElement(
                        _components.ListItem,
                        {
                          fullWidth: true,
                          key: tracks[trackIndex].id,
                          className: (0, _bind2.default)(styles.trackRow, (0, _defineProperty3.default)({}, styles.denied, _this5.isTrackDenied({ track: tracks[trackIndex], album: album })))
                        },
                        _react2.default.createElement(
                          'div',
                          { className: 'text-center width-perc-1', onClick: function onClick() {
                              return _this5.play(trackIndex);
                            } },
                          _react2.default.createElement(_TrackPlayPauseButton2.default, {
                            track: tracks[trackIndex],
                            album: album,
                            showTrackNumber: true,
                            trackNumber: tracks[trackIndex].track_number,
                            isDenied: _this5.isTrackDenied({ track: tracks[trackIndex], album: album })
                          })
                        ),
                        _react2.default.createElement(
                          'div',
                          { onClick: function onClick() {
                              return _this5.play(trackIndex);
                            } },
                          tracks[trackIndex].trackName
                        ),
                        _react2.default.createElement(
                          'div',
                          { className: styles.timeCell, onClick: function onClick() {
                              return _this5.play(trackIndex);
                            } },
                          currentTrack.id === tracks[trackIndex].id ? humanizedPosition : tracks[trackIndex].durationTime
                        ),
                        user && _react2.default.createElement(
                          'div',
                          { className: styles.addPlaylistCell },
                          !_this5.isTrackDenied({ track: tracks[trackIndex], album: album }) && _react2.default.createElement(_MyPlaylistsAddIcon2.default, { track: tracks[trackIndex] })
                        ),
                        album.downloadable && _react2.default.createElement(
                          'div',
                          { className: styles.checkCell },
                          _react2.default.createElement(_components.Checkbox, {
                            className: 'padding-5 inline',
                            checked: checkedTracks[tracks[trackIndex].track_number],
                            small: true,
                            thin: true,
                            onChange: function onChange(e) {
                              return _this5.toggleTrackChecked(e, tracks[trackIndex].track_number);
                            }
                          })
                        )
                      );
                    })
                  )
                );
              })
            ),
            album.audiovideo === _projects.projectTypes.video && tracks.map(function (track) {
              return _react2.default.createElement(
                'div',
                { key: track.id, className: 'margin-vert-20' },
                _react2.default.createElement(
                  'h4',
                  null,
                  track.track_number,
                  '. ',
                  track.trackName
                ),
                _react2.default.createElement(
                  _reactHtml5video.DefaultPlayer,
                  {
                    controls: ['PlayPause', 'Seek', 'Time', 'Volume', 'Fullscreen'],
                    onEnded: function onEnded(e) {
                      return _this5.onVideoEnded(e, track);
                    }
                  },
                  _react2.default.createElement('source', { src: track.videoSrc, type: 'video/mp4' })
                )
              );
            }),
            _react2.default.createElement(
              'div',
              { className: 'table width-perc-100' },
              _react2.default.createElement(
                'div',
                { className: 'table-cell text-right' },
                album.downloadable && _react2.default.createElement(
                  'span',
                  null,
                  _react2.default.createElement(
                    'span',
                    { className: styles.downloadFormat },
                    _react2.default.createElement(
                      'span',
                      { className: 'margin-10' },
                      t('Download format')
                    ),
                    this.renderFormatCheckbox('wav'),
                    this.renderFormatCheckbox('mp3')
                  ),
                  _react2.default.createElement(_components.DownloadTracksButton, {
                    className: 'margin-top-10 margin-left-15',
                    format: format,
                    playlistUser: playlistUser,
                    requireAuth: !user,
                    contentKey: playlistKey,
                    tracksNumbers: this.getCheckedTracksArray()
                  })
                ),
                album.isPress && _react2.default.createElement(
                  'button',
                  {
                    className: 'btn btn-primary margin-top-10 margin-left-15',
                    onClick: function onClick() {
                      return _this5.downloadPress();
                    },
                    disabled: pressLoading
                  },
                  t('Press Pack')
                ),
                this.renderContentButton()
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'hint small text-justify margin-top-20' },
              album.iSpec
            ),
            _react2.default.createElement(_PlaylistFeedbackForm2.default, { album: album, line: !user })
          )
        )
      );
    }
  }]);
  return Playlist;
}(_react.Component), _class3.propTypes = {
  album: _propTypes2.default.object,
  autoPlayIndex: _propTypes2.default.number,
  clearPlaylistError: _propTypes2.default.func,
  currentTrackIndex: _propTypes2.default.number,
  format: _propTypes2.default.string,
  humanizedPosition: _propTypes2.default.string,
  loadPress: _propTypes2.default.func,
  location: _propTypes2.default.object,
  partTracks: _propTypes2.default.object,
  playAlbum: _propTypes2.default.func,
  playerAlbum: _propTypes2.default.object,
  playerStatus: _propTypes2.default.string,
  playerTracks: _propTypes2.default.array,
  playlistEmail: _propTypes2.default.string,
  playlistKey: _propTypes2.default.string,
  playlistLoadError: _propTypes2.default.object,
  playlistLoading: _propTypes2.default.bool,
  playlistName: _propTypes2.default.string,
  playlistSurname: _propTypes2.default.string,
  playlistUser: _propTypes2.default.object,
  playStatsAlbums: _propTypes2.default.object,
  playStatsTracks: _propTypes2.default.object,
  pressLoading: _propTypes2.default.bool,
  pushState: _propTypes2.default.func,
  replaceState: _propTypes2.default.func,
  selectFormat: _propTypes2.default.func,
  setLoginData: _propTypes2.default.func,
  setRedirect: _propTypes2.default.func,
  t: _propTypes2.default.func,
  tracks: _propTypes2.default.array,
  typeFilter: _propTypes2.default.string,
  user: _propTypes2.default.object
}, _class3.defaultProps = {
  playStatsAlbums: {},
  playStatsTracks: {}
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'renderFormatCheckbox', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'renderFormatCheckbox'), _class2.prototype)), _class2)) || _class) || _class) || _class);
exports.default = Playlist;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Playlist/Playlist.js
// module id = 2178
// module chunks = 1